require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-gr-8-paper-push-2023.json") })
        }
      }, "path---es-articles-gr-8-paper-push-2023");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-gr-8-paper-push-2023!./.cache/json/es-articles-gr-8-paper-push-2023.json
// module id = 2204
// module chunks = 231608221292675